var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 8.1665H4.66732C3.37865 8.1665 2.33398 9.21117 2.33398 10.4998V20.9998C2.33398 22.2885 3.37865 23.3332 4.66732 23.3332H23.334C24.6227 23.3332 25.6673 22.2885 25.6673 20.9998V10.4998C25.6673 9.21117 24.6227 8.1665 23.334 8.1665Z",
    fill: "#737A83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.1665H7L9.33333 4.6665H18.6667L21 8.1665Z",
    fill: "#737A83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 20.416C16.8995 20.416 19.25 18.0655 19.25 15.166C19.25 12.2665 16.8995 9.91602 14 9.91602C11.1005 9.91602 8.75 12.2665 8.75 15.166C8.75 18.0655 11.1005 20.416 14 20.416Z",
    fill: "#C7CED5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0007 18.0828C15.6115 18.0828 16.9173 16.777 16.9173 15.1662C16.9173 13.5553 15.6115 12.2495 14.0007 12.2495C12.3898 12.2495 11.084 13.5553 11.084 15.1662C11.084 16.777 12.3898 18.0828 14.0007 18.0828Z",
    fill: "#737A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.4ba8a8f6a1fef73126b1aa16b18b7076.svg";
export { ForwardRef as ReactComponent };